module.exports = __webpack_public_path__ + "static/media/16.d7bf227a.JPG";